// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__GyWsI","btn":"error_btn__RBc_2"};